import actions from "@/store/modules/player/actions";
import mutations from "@/store/modules/player/mutations";
import state from "@/store/modules/player/state";

export default {
    actions,
    mutations,
    state
}